import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

interface LinkContractsToBuildingRequest {
  facilityId: number;
  contractNumbers: string[];
}

@Injectable({ providedIn: 'root' })
export class BuildingUtilityContractService {
  private readonly adminBaseUrl = environment.apiBaseAdminUrl;

  constructor(private http: HttpClient) {}

  linkContractsToBuilding(buildingId: number, facilityId: number, contractNumbers: string[]): Observable<void> {
    const body: LinkContractsToBuildingRequest = { facilityId, contractNumbers };
    return this.http.put<void>(`${this.adminBaseUrl}/buildings/${buildingId}/utilityContracts:link`, body);
  }

  unlinkContractsFromBuilding(contractNumbers: string[]): Observable<void> {
    const body = { contractNumbers };
    return this.http.put<void>(`${this.adminBaseUrl}/buildings/utilityContracts:unlink`, body);
  }
}
